function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('./../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var SaitoCamera = require('../../lib/saito/ui/saito-camera/saito-camera');
var SaitoMain = require('./lib/main');
var RedSquareMenu = require('./lib/menu');
var TweetMenu = require('./lib/tweet-menu');
var Tweet = require('./lib/tweet');
var redsquareHome = require('./index');
var Post = require('./lib/post');
var Transaction = require('../../lib/saito/transaction')["default"];
var PeerService = require('saito-js/lib/peer_service')["default"];
var SaitoOverlay = require('./../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoPost = require('./../../lib/saito/ui/saito-post/saito-post');
var AppSettings = require('./lib/settings');

////////////////////////////////////////////
//
// RedSquare depends on the Archive module for TX storage. This allows the
// module to fetch tweets from multiple machines using a consistent API,
// the loadTransactions() function.
//
// Transactions are fetched and submitted to the addTweet() function which
// creates a tweet /lib/tweet.js which is responsible for formatting and
// displaying itself as and when requested.
//
// On initial load the module fetches from localhost. Whenever peers that
// support Archives are added, they are added to a list of peers from
// which tweets can be requested.
//
/**
 * As of 11/20/2025, RedSquare works thusly:
 *
 * Servers feed a set a tweets in the index.html
 * Browsers generate those and requests tweets from each peer it establishes.
 *
 * Server maintains a list of tweets in memory.
 * As browsers scroll down, they send a peerRequest to RedSquare server for the next ten tweets
 *
 * Server hits Archive to load older tweets into memory as needed
 *
 * Refreshing (checking for new tweets) is a remote (only) Archive fetch
 *
 *
 */
///////////////////////////////////////////
var RedSquare = /*#__PURE__*/function (_ModTemplate) {
  function RedSquare(app) {
    var _this;
    _classCallCheck(this, RedSquare);
    _this = _callSuper(this, RedSquare, [app]);
    _this.appname = 'Red Square';
    _this.name = 'RedSquare';
    _this.slug = 'redsquare';
    _this.description = 'Open Source Twitter-clone for the Saito Network';
    _this.categories = 'Social Entertainment';
    _this.icon_fa = 'fas fa-square-full';
    _this.dependencies = ['Archive', 'Registry'];
    _this.debug = false;
    _this.tweets = []; // time sorted master list of tweets
    _this.cached_tweets = []; // serialized-for-web version of curated_tweets
    _this.last_cache = 0; // to prevent updating cache too frequently

    _this.tweets_sigs_hmap = {};
    _this.special_threads_hmap = {};
    _this.unknown_children = [];
    _this.orphan_edits = [];
    _this.blogs = [];
    _this.peers = [];
    _this.keylist = {};
    _this.tweet_count = 0;
    _this.liked_tweets = [];
    _this.retweeted_tweets = [];
    _this.replied_tweets = [];
    _this.hidden_tweets = [];
    _this.notifications = [];
    _this.notifications_sigs_hmap = {};
    _this.jedi_council = new Map();

    //
    // controls whether non-curated tweets will render
    //
    _this.curated = !_this.debug;
    _this.possibleHome = 1;
    _this.use_floating_plus = 1;

    //
    // is this a notification?
    //
    _this.notifications_earliest_tweet_ts = new Date().getTime();
    _this.notifications_earliest_like_ts = new Date().getTime();
    _this.notifications_last_viewed_ts = 0;
    _this.notifications_number_unviewed = 0;
    _this.tweets_earliest_ts = new Date().getTime();
    _this.allowed_upload_types = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif', 'image/webp'];
    _this.styles = ['/redsquare/style.css'];
    _this.postScripts = ['/saito/lib/emoji-picker/emoji-picker.js'];
    _this.enable_profile_edits = true;

    //
    // This is the default Open Graph Card for Redsquare
    // If we have a link to a specific tweet, we will use a different object to populate the
    // generated html in the webserver
    //
    _this.social = {
      twitter: '@SaitoOfficial',
      title: '🟥 Saito RedSquare - Web3 Social Media',
      url: 'https://saito.io/redsquare/',
      description: 'Peer to peer Web3 social media platform',
      image: 'https://saito.tech/wp-content/uploads/2022/04/saito_card.png' //square image with "Saito" below logo
      //image: "https://saito.tech/wp-content/uploads/2022/04/saito_card_horizontal.png",
    };
    _this.app.connection.on('saito-render-complete', function () {
      _this.app.connection.emit('redsquare-update-notifications', _this.notifications_number_unviewed);
    });
    _this.app.connection.on('redsquare-new-post', function (msg) {
      var post = new Post(_this.app, _this);
      post.render();
    });
    _this.app.connection.on('redsquare-post-tweet', function (data, keys) {
      _this.sendTweetTransaction(_this.app, _this, data, keys);
    });
    _this.app.connection.on('redsquare-home-render-request', function () {
      if (_this.browser_active && _this.orphan_edits.length > 0) {
        var orphans = _this.orphan_edits;
        _this.orphan_edits = [];
        for (var i = 0; i < orphans.length; i++) {
          _this.editTweet(orphans[i].tweet_id, orphans[i].tx, orphans[i].source);
        }
        console.debug("RS.home-render-request ".concat(orphans.length - _this.orphan_edits.length, " orphaned edits processed!"));
      }
    });
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(RedSquare, _ModTemplate);
  return _createClass(RedSquare, [{
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER || this.offerService) {
        services.push(this.app.network.createPeerService(null, 'redsquare', 'RedSquare Tweet Archive'));
      }
      return services;
    }

    /////////////////////////////////
    // inter-module communications //
    /////////////////////////////////
  }, {
    key: "respondTo",
    value: function respondTo() {
      var _this2 = this;
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var obj = arguments.length > 1 ? arguments[1] : undefined;
      var this_mod = this;
      if (type === 'user-menu') {
        return {
          text: "".concat(obj !== null && obj !== void 0 && obj.publicKey && obj.publicKey === this.publicKey ? 'My' : 'View', " RedSquare Profile"),
          icon: 'fa fa-user',
          callback: function callback(app, publicKey) {
            if (this_mod !== null && this_mod !== void 0 && this_mod.menu) {
              this_mod.menu.openProfile(publicKey);
            } else {
              navigateWindow("/redsquare/?user_id=".concat(publicKey));
            }
          }
        };
      }
      if (type === 'saito-header') {
        var x = [];
        if (!this.browser_active) {
          x.push({
            text: 'RedSquare',
            icon: 'fa-solid fa-square',
            rank: 20,
            type: 'navigation',
            callback: function callback(app, id) {
              navigateWindow('/redsquare');
            },
            event: function event(id) {
              this_mod.app.connection.on('redsquare-update-notifications', function (unread) {
                this_mod.app.browser.addNotificationToId(unread, id);
                this_mod.app.connection.emit('saito-header-notification', 'redsquare', unread);
              });
            }
          });
        } else {
          if (this.app.browser.isMobileBrowser() || window.innerWidth < 600) {
            x.push({
              text: 'RedSquare Home',
              icon: 'fa-solid fa-house',
              rank: 21,
              type: 'appspace',
              callback: function callback(app, id) {
                document.querySelector('.redsquare-menu-home').click();
              }
            });
            x.push({
              text: 'Notifications',
              icon: 'fas fa-bell',
              rank: 23,
              type: 'appspace',
              callback: function callback(app, id) {
                document.querySelector('.redsquare-menu-notifications').click();
              },
              event: function event(id) {
                this_mod.app.connection.on('redsquare-update-notifications', function (unread) {
                  this_mod.app.browser.addNotificationToId(unread, id);
                  this_mod.app.connection.emit('saito-header-notification', 'redsquare', unread);
                });
              }
            });
            x.push({
              text: 'Profile',
              icon: 'fas fa-user',
              rank: 26,
              type: 'appspace',
              callback: function callback(app, id) {
                document.querySelector('.redsquare-menu-profile').click();
              }
            });
          }
        }
        return x;
      }
      if (type === 'saito-floating-menu') {
        var _x = [];
        _x.push({
          text: 'Tweet',
          icon: 'fa-solid fa-pen',
          is_active: this.browser_active,
          disallowed_mods: ['arcade'],
          rank: 10,
          callback: function callback(app, id) {
            var post = new Post(app, this_mod);
            post.render();
          }
        });
        _x.push({
          text: 'Tweet Camera',
          icon: 'fas fa-camera',
          is_active: this.browser_active,
          disallowed_mods: ['arcade'],
          rank: 30,
          callback: function callback(app, id) {
            var post = new Post(app, this_mod);
            var camera = new SaitoCamera(app, this_mod, function (img) {
              post.render();
              post.addImg(img);
            });
            camera.render();
          }
        });
        _x.push({
          text: 'Tweet Image',
          icon: 'fas fa-image',
          is_active: this.browser_active,
          disallowed_mods: ['arcade'],
          rank: 20,
          callback: function callback(app, id) {
            var post = new Post(app, this_mod);
            post.render();
            post.triggerClick('#hidden_file_element_tweet-overlay');
          }
        });
        return _x;
      }
      if (type == 'game-menu') {
        //this.attachStyleSheets();
        //super.render(this.app, this);
        return {
          //id: 'game-share',
          //text: 'Share',
          submenus: [{
            parent: 'game-share',
            text: 'Tweet',
            id: 'game-tweet',
            "class": 'game-tweet',
            callback: function callback(app, game_mod) {
              game_mod.menu.hideSubMenus();
              var post = new Post(app, this_mod);
              post.render();
            }
          }]
        };
      }
      if (type === 'post-content') {
        return {
          icon: this_mod.icon_fa,
          text: 'Continue with post to RedSquare',
          callback: function () {
            var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(content, image) {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    this_mod.app.connection.emit('continue-with-redsquare');
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            function callback(_x2, _x3) {
              return _callback.apply(this, arguments);
            }
            return callback;
          }()
        };
      }

      //
      // curation / moderation functions
      //
      // all tweets received are passed through this function, which indicates whether they
      // pass the curation function. -1 = fail / 0 = unsure / 1 = pass
      //
      if (type === 'saito-moderation-app') {
        return {
          //
          // default curation logic...
          //
          filter_func: function filter_func() {
            var mod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var tx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            if (tx == null || mod == null || !(tx !== null && tx !== void 0 && tx.from)) {
              return 0;
            }
            if (mod.name !== _this2.name) {
              return 0;
            }
            if (_this2.hidden_tweets.includes(tx.signature)) {
              console.log('HIDDEN TWEET!!!!!');
              return -1;
            }
            return 0;
          }
        };
      }
      return null;
    }

    ////////////////////
    // initialization //
    ////////////////////
    //
    // this function runs whenever the browser or application is loaded. note that
    // at this point we probably do not have any network connections to any peers
    // so most of the work is pre-network init.
    //
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app) {
        var _this3 = this;
        var pr, user_id, tweet_id, pending, i, tx, txmsg, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return _superPropGet(RedSquare, "initialize", this, 3)([app]);
            case 1:
              if (this.app.BROWSER && !this.browser_active) {
                this.debug = false;
              }

              //
              // ensure easy-access in non-awaitable
              //
              _context2.n = 2;
              return app.wallet.getPublicKey();
            case 2:
              this.publicKey = _context2.v;
              //
              // fetch content from options file
              //
              this.loadOptions();
              if (app.BROWSER) {
                _context2.n = 3;
                break;
              }
              //////////////////////////////////
              // Special processing for servers
              //////////////////////////////////
              pr = this.addPeer('localhost', 100);
              this.loadTweets('earlier', function (tx_count) {
                // Use curation to bootstrap jedi council
                var _iterator = _createForOfIteratorHelper(_this3.tweets),
                  _step;
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    var tweet = _step.value;
                    if (tweet.curated == 1) {
                      _this3.addToCouncil(tweet.tx.from[0].publicKey);
                    }
                  }

                  // Create cache to serve with index.js
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
                _this3.cacheRecentTweets();
                console.debug("RS -- Preloaded ".concat(tx_count, " transactions ~~ ").concat(_this3.tweets.length, " tweets"));
              }, pr);

              ///
              // We just want the metadata from the archive, lol
              ///
              /*let archive_mod = this.app.modules.returnModule('Archive');
              if (archive_mod) {
                archive_mod.loadTransactionsWithCallback({ field1: 'Blog', limit: 50 }, (res) => {
                  for (let i = 0; i < res.length; i++) {
                    this.blogs.push({
                      ts: res[i].updated_at,
                      publicKey: res[i].field2,
                      tx_id: res[i].sig
                    });
                  }
                   this.addBlogPseudoTweets();
                });
              }*/
              return _context2.a(2);
            case 3:
              //
              // add myself as peer...
              //
              this.addPeer('localhost');

              //
              // check tweets in pending txs
              //
              _context2.p = 4;
              user_id = this.app.browser.returnURLParameter('user_id');
              tweet_id = this.app.browser.returnURLParameter('tweet_id');
              if (!(!tweet_id || !user_id)) {
                _context2.n = 6;
                break;
              }
              _context2.n = 5;
              return app.wallet.getPendingTransactions();
            case 5:
              pending = _context2.v;
              for (i = 0; i < pending.length; i++) {
                tx = pending[i];
                txmsg = tx.returnMessage();
                if (txmsg && txmsg.module == this.name) {
                  if (txmsg.request === 'create tweet') {
                    this.addTweet(tx, {
                      type: 'pending_tx',
                      node: 'wallet'
                    });
                  }
                }
              }
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t = _context2.v;
            case 8:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 7]]);
      }));
      function initialize(_x4) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }() ////////////
    // render //
    ////////////
    //
    // browsers run this to render the page. this also runs before the network is
    // likely functional, so it focuses on writing the components to the screen rather
    // that fetching content.
    //
    // content is loaded from the local cache, and then the "loading new tweets" indicator
    // is enabled, and when onPeerServiceUp() triggers we run a postcache-render-request
    // to update the page if it is in a state where that is permitted.
    //
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _window;
        var z, newtx, _iterator2, _step2, mod, cm;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!this.app.BROWSER || !this.browser_active)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              // Create here so only in browser_active browsers...
              this.sPost = new SaitoPost(this.app, this);
              if ((_window = window) !== null && _window !== void 0 && (_window = _window.tweets) !== null && _window !== void 0 && _window.length) {
                for (z = 0; z < window.tweets.length; z++) {
                  newtx = new Transaction();
                  newtx.deserialize_from_web(this.app, window.tweets[z]);
                  this.addTweet(newtx, {
                    type: 'server-cache',
                    node: 'server'
                  } /*, 1*/);
                }
              }

              //
              // create and render components
              //
              if (!(this.main == null)) {
                _context3.n = 3;
                break;
              }
              this.main = new SaitoMain(this.app, this);
              this.header = new SaitoHeader(this.app, this);
              _context3.n = 2;
              return this.header.initialize(this.app);
            case 2:
              this.menu = new RedSquareMenu(this.app, this, '.saito-sidebar.left');
              this.tweetMenu = new TweetMenu(this.app, this);
              this.addComponent(this.header);
              this.addComponent(this.main);
              this.addComponent(this.menu);

              //
              // chat manager goes in left-sidebar
              //
              _iterator2 = _createForOfIteratorHelper(this.app.modules.returnModulesRespondingTo('chat-manager'));
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  mod = _step2.value;
                  cm = mod.respondTo('chat-manager');
                  cm.container = '.saito-sidebar.left';
                  cm.render_manager_to_screen = 1;
                  this.addComponent(cm);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            case 3:
              _context3.n = 4;
              return _superPropGet(RedSquare, "render", this, 3)([]);
            case 4:
              //
              // render right-sidebar components
              //
              this.app.modules.renderInto('.redsquare-sidebar');
              if (!this.app.modules.returnModule('Archive')) {
                salert('RedSquare will not work without Archive installed!');
              }
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }() /////////////////////
    // peer management //
    /////////////////////
  }, {
    key: "addPeer",
    value: function addPeer(peer) {
      var _this4 = this;
      var tweet_limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var publicKey = (peer === null || peer === void 0 ? void 0 : peer.publicKey) || this.publicKey;
      var peer_idx = -1;
      for (var i = 0; i < this.peers.length; i++) {
        if (this.peers[i].publicKey === publicKey) {
          peer_idx = i;
        }
      }
      var peer_obj;
      if (peer_idx == -1) {
        peer_obj = {
          peer: peer,
          publicKey: publicKey,
          tweets_earliest_ts: new Date().getTime(),
          tweets_latest_ts: 0,
          tweets_limit: tweet_limit,
          busy: {}
        };
        this.peers.push(peer_obj);
      } else {
        this.peers[peer_idx].peer = peer;
        peer_obj = this.peers[peer_idx];
        // console.log('RS.addPeer: peer refreshed -- ', peer_obj);
        return peer_obj;
      }

      // Only set interval on new peers, (so we aren't setting multiple on network instability)
      if (this.browser_active) {
        this.loadTweets('later', function (tx_count) {
          _this4.app.connection.emit('redsquare-home-postcache-render-request', tx_count);
        }, peer_obj);

        //
        // auto-poll for new tweets, on 5 minute interval
        //
        if (peer.publicKey !== this.publicKey) {
          setInterval(function () {
            _this4.loadTweets('later', function (tx_count) {
              _this4.app.connection.emit('redsquare-home-postcache-render-request', tx_count);
            }, peer_obj);
          }, 300000);
        }
      }
      return peer_obj;
    }

    ////////////////////////
    // when peer connects //
    ////////////////////////
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(app, peer) {
        var service,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              service = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              if (this.browser_active) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              //
              // redsquare -- load tweets
              //
              if (service.service === 'redsquare') {
                //
                // add service peer, query and set up interval to poll every 5 minutes
                //

                this.addPeer(peer);
                this.archive_connected = true;
                if (this.browser_active) {
                  //siteMessage('Syncing Redsquare...', 2000);
                  this.main.render();
                }
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onPeerServiceUp(_x5, _x6) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }() ///////////////////////
    // network functions //
    ///////////////////////
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app) {
        var _this5 = this;
        var tx,
          peer,
          mycallback,
          txmsg,
          txs,
          thread_id,
          by_thread,
          tweet,
          root_tweet,
          need_to_check_archive,
          i,
          last_index,
          _args5 = arguments;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              tx = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : null;
              peer = _args5.length > 2 ? _args5[2] : undefined;
              mycallback = _args5.length > 3 ? _args5[3] : undefined;
              if (!(tx == null)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, 0);
            case 1:
              txmsg = tx.returnMessage();
              if (!(!txmsg.request || !mycallback)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, 0);
            case 2:
              txs = [];
              if (!(txmsg.request === 'load thread')) {
                _context5.n = 7;
                break;
              }
              thread_id = txmsg.data.sig;
              by_thread = false;
              console.log('========> LOAD THREAD REQUEST ===========');
              tweet = this.returnTweet(thread_id);
              if (!tweet) {
                _context5.n = 6;
                break;
              }
              if (!(tweet.thread_id == thread_id)) {
                _context5.n = 4;
                break;
              }
              if (!tweet.isLoaded()) {
                _context5.n = 3;
                break;
              }
              return _context5.a(2, mycallback(this.packTweetThread(tweet)));
            case 3:
              by_thread = true;
              _context5.n = 6;
              break;
            case 4:
              console.log('========> Provided sig not the THREAD ROOT =============');
              thread_id = tweet.thread_id;
              root_tweet = this.returnTweet(tweet.thread_id);
              if (!root_tweet) {
                _context5.n = 6;
                break;
              }
              if (!root_tweet.isLoaded()) {
                _context5.n = 5;
                break;
              }
              return _context5.a(2, mycallback(this.packTweetThread(root_tweet)));
            case 5:
              by_thread = true;
            case 6:
              console.log('========> HITTING ARCHIVES! ===========');
              if (by_thread) {
                this.app.storage.loadTransactions({
                  field1: 'RedSquare',
                  field5: thread_id,
                  flagged: 0,
                  limit: 100
                }, function (txs) {
                  if (txs.length > 0) {
                    console.log('========> ARCHIVES FOUND THREAD =====');
                    mycallback(txs);
                  }
                }, 'localhost', 0);
              } else {
                this.app.storage.loadTransactions({
                  sig: thread_id,
                  field1: 'RedSquare'
                }, function (txs) {
                  if (txs.length > 0) {
                    txs[0].decryptMessage(_this5.app);
                    var archive_returned_tweet = new Tweet(_this5.app, _this5, txs[0]);
                    _this5.app.storage.loadTransactions({
                      field1: 'RedSquare',
                      field5: archive_returned_tweet.thread_id,
                      flagged: 0,
                      limit: 100
                    }, function (txs) {
                      if (txs.length > 0) {
                        console.log('========> ARCHIVES FOUND THREAD AFTER TWEET LOOKUP =====');
                        mycallback(txs);
                      }
                    }, 'localhost', 0);
                  }
                }, 'localhost');
              }
              return _context5.a(2, 1);
            case 7:
              if (!(txmsg.request === 'load tweets')) {
                _context5.n = 12;
                break;
              }
              console.log('Peer Request to load tweets....');
              if (!(txmsg.data.created_earlier_than != undefined)) {
                _context5.n = 12;
                break;
              }
              need_to_check_archive = true;
              i = 0;
            case 8:
              if (!(i < this.tweets.length)) {
                _context5.n = 10;
                break;
              }
              if (!(this.tweets[i].created_at < txmsg.data.created_earlier_than)) {
                _context5.n = 9;
                break;
              }
              txs.push(this.tweets[i].tx.serialize_to_web(app));
              if (!(txs.length == 10)) {
                _context5.n = 9;
                break;
              }
              need_to_check_archive = false;
              return _context5.a(3, 10);
            case 9:
              i++;
              _context5.n = 8;
              break;
            case 10:
              if (need_to_check_archive) {
                console.log('Pulling earlier tweets from archive to give to peer');
                last_index = this.tweets.length;
                need_to_check_archive = this.loadTweets('earlier', function (count, peer) {
                  /*
                  let optjson = JSON.stringify(this.tweets, (key, value) => {
                  if (key == 'app') return 'app';
                  if (key == 'mod') return 'mod';
                  return typeof value === 'bigint' ? value.toString() : value; // return everything else unchanged
                  });
                  console.debug(
                  `\n===\nEstimated RS Cache -- Memory load -- ${this.tweets.length} tweets, ${(optjson.length / 1048576).toFixed(3)}MB\n===\n`
                  );
                  */

                  for (var _i = last_index; _i < _this5.tweets.length; _i++) {
                    txs.push(_this5.tweets[_i].tx.serialize_to_web(app));
                    if (txs.length == 10) {
                      break;
                    }
                  }

                  //
                  // I guess it is possible *not* to hit the full 10 even after pulling 50 txs...
                  //
                  mycallback(txs);
                  _this5.addBlogPseudoTweets();
                }, this.peers[0]);
              }

              // Call user callback on either the tweets that the server has in memory, or
              // on the empty [] if the server's local archive taps out of results...
              if (need_to_check_archive) {
                _context5.n = 11;
                break;
              }
              return _context5.a(2, mycallback(txs));
            case 11:
              return _context5.a(2, 1);
            case 12:
              return _context5.a(2, _superPropGet(RedSquare, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee5, this);
      }));
      function handlePeerTransaction(_x7) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }() //
    // messages arrive on-chain over the network here
    //
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              txmsg = tx.returnMessage();
              if (!(conf == 0)) {
                _context6.n = 9;
                break;
              }
              if (!(txmsg.request === 'delete tweet')) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return this.receiveDeleteTransaction(blk, tx, conf, this.app);
            case 1:
              return _context6.a(2);
            case 2:
              if (!(txmsg.request === 'edit tweet')) {
                _context6.n = 4;
                break;
              }
              _context6.n = 3;
              return this.receiveEditTransaction(blk, tx, conf, this.app);
            case 3:
              return _context6.a(2);
            case 4:
              if (this.app.BROWSER) {
                this.addNotification(tx);
              }
              if (!(txmsg.request === 'create tweet')) {
                _context6.n = 6;
                break;
              }
              _context6.n = 5;
              return this.receiveTweetTransaction(blk, tx, conf, this.app);
            case 5:
              this.addTweet(tx, {
                type: 'on chain',
                node: blk.id
              });
            case 6:
              if (!(txmsg.request === 'like tweet')) {
                _context6.n = 7;
                break;
              }
              _context6.n = 7;
              return this.receiveLikeTransaction(blk, tx, conf, this.app);
            case 7:
              if (!(txmsg.request === 'flag tweet')) {
                _context6.n = 8;
                break;
              }
              _context6.n = 8;
              return this.receiveFlagTransaction(blk, tx, conf, this.app);
            case 8:
              if (!(txmsg.request === 'retweet')) {
                _context6.n = 9;
                break;
              }
              _context6.n = 9;
              return this.receiveRetweetTransaction(blk, tx, conf, this.app);
            case 9:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onConfirmation(_x8, _x9, _x0) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }() ///////////////////////////////
    // content loading functions //
    ///////////////////////////////
    //
    // there are three major functions that are called to fetch more content:
    //
    // - loadProfile()
    // - loadTweets()
    // - loadNotifications()
    //
    // these will trigger calls to all of the peers that have been added and
    // fetch more content from all of them up until there is no more content
    // to fetch and display. this content will be fetched and returned in the
    // form of transactions that can be fed to addTweets()
    //
  }, {
    key: "loadTweets",
    value: function loadTweets() {
      var _this6 = this;
      var created_at = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'earlier';
      var mycallback = arguments.length > 1 ? arguments[1] : undefined;
      var peer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      //
      // Instead of just passing the txs to the callback, we count how many of these txs
      // are new to us so we can have a better UX
      //
      var peer_count = 0;
      var _loop = function _loop(i) {
        if (!peer || peer.publicKey == _this6.peers[i].publicKey) {
          if (created_at == 'earlier' && _this6.peers[i].tweets_earliest_ts >= _this6.tweets_earliest_ts && _this6.peers[i].tweets_earliest_ts > 0 || created_at == 'later' && (_this6.peers[i].publicKey !== _this6.publicKey || peer)) {
            peer_count++;
            if (_this6.peers[i].busy[created_at]) {
              _this6.peers[i].busy[created_at].push(mycallback);
              console.warn('RS.loadTweets already waiting on a response from this peer!');
              return 1; // continue
            }
            _this6.peers[i].busy[created_at] = [mycallback];

            //
            // Use the "fast load" method for scrolling DOWN the feed
            //
            if (created_at == 'earlier' && _this6.peers[i].publicKey !== _this6.publicKey) {
              var obj = {
                created_earlier_than: _this6.peers[i].tweets_earliest_ts
              };
              _this6.app.network.sendRequestAsTransaction('load tweets', obj, function (txs) {
                for (var t = 0; t < txs.length; t++) {
                  var tx = new Transaction();
                  tx.deserialize_from_web(_this6.app, txs[t]);
                  txs[t] = tx;
                }
                var count = _this6.processTweetsFromPeer(_this6.peers[i], txs);
                if (txs.length == 0) {
                  console.debug('RS: Mark remote peer as tapped out...');
                  _this6.peers[i].tweets_earliest_ts = 0;
                  //this.tweets_earliest_ts = 0;
                }
                console.debug("RS.loadTweets remote [".concat(created_at, "] returned ").concat(count, ". New feed length: ").concat(_this6.tweets.length));
                var _iterator3 = _createForOfIteratorHelper(_this6.peers[i].busy[created_at]),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var cb = _step3.value;
                    if (typeof cb === 'function') {
                      cb(count, _this6.peers[i]);
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                _this6.peers[i].busy[created_at] = null;
              }, _this6.peers[i].peer.publicKey);
            } else {
              console.debug("RS.loadTweets requesting ".concat(created_at, " tweets from archive..."));
              var _obj = {
                field1: 'RedSquare',
                flagged: 0,
                //tx_size_less_than: 1330000,
                limit: _this6.peers[i].tweets_limit
              };
              if (created_at == 'earlier') {
                _obj.created_earlier_than = _this6.peers[i].tweets_earliest_ts;
              } else if (created_at == 'later') {
                _obj.updated_later_than = _this6.peers[i].tweets_latest_ts;
              }
              _this6.app.storage.loadTransactions(_obj, function (txs) {
                var count = _this6.processTweetsFromPeer(_this6.peers[i], txs);
                if (txs.length == 0) {
                  if (created_at === 'earlier') {
                    console.debug('RS: Mark peer as tapped out: ' + created_at);
                    _this6.peers[i].tweets_earliest_ts = 0;
                    _this6.tweets_earliest_ts = 0;
                  }
                }
                console.debug("RS.loadTweets ".concat(_this6.peers[i].publicKey == _this6.publicKey ? 'localhost' : _this6.peers[i].publicKey.substring(0, 6), " [").concat(created_at, "] returned ").concat(count, "/").concat(txs.length, ". New feed length: ").concat(_this6.tweets.length));
                var _iterator4 = _createForOfIteratorHelper(_this6.peers[i].busy[created_at]),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                    var cb = _step4.value;
                    if (typeof cb === 'function') {
                      cb(count, _this6.peers[i]);
                    }
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                _this6.peers[i].busy[created_at] = null;
              }, _this6.peers[i].peer);
            }
          }
        }
      };
      for (var i = 0; i < this.peers.length; i++) {
        if (_loop(i)) continue;
      }
      if (!peer_count) {
        console.debug('Ignore load tweets because no peers available: ', JSON.parse(JSON.stringify(this.peers)), created_at, this.tweets_earliest_ts);
      }
      return peer_count;
    }
  }, {
    key: "processTweetsFromPeer",
    value: function processTweetsFromPeer(peer, txs) {
      var count = 0;

      //
      // sanity-check in case blocked tweets have come through via
      // saving in local-storage or whitelisting by peers.
      //
      if (this.debug) {
        console.debug("RS.processTweetsFromPeer: checking ".concat(txs.length, " tweet transaction against my current ").concat(this.tweets.length));
      }
      for (var z = 0; z < txs.length; z++) {
        var _txs$z$optional;
        txs[z].decryptMessage(this.app);

        //////////////////////////////////////////////////
        // if (this.browser_active) console.log(txs[z].timestamp, txs[z].updated_at);
        //////////////////////////////////////////////////
        var created_at = txs[z].timestamp;
        var updated_at = ((_txs$z$optional = txs[z].optional) === null || _txs$z$optional === void 0 ? void 0 : _txs$z$optional.updated_at) || created_at;
        if (created_at < peer.tweets_earliest_ts) {
          peer.tweets_earliest_ts = created_at;
          this.tweets_earliest_ts = Math.min(this.tweets_earliest_ts, peer.tweets_earliest_ts);
        }
        if (updated_at > peer.tweets_latest_ts) {
          peer.tweets_latest_ts = updated_at;
        }
        var source = {
          type: 'archive',
          node: peer.publicKey || peer
        };
        if (peer.publicKey == this.publicKey) {
          source.node = 'localhost';
        }
        var added = this.addTweet(txs[z], source);
        var tweet = this.returnTweet(txs[z].signature);
        if (tweet && added > 0) {
          //
          // save w. metadata
          //
          if (peer.publicKey != this.publicKey) {
            this.saveTweet(tweet, 0);
          }
          count += added;
        }
      }
      return count;
    }

    //
    // We have two types of notifications that are slightly differently indexed, so
    // we are doing some fancy work to load all the transactions into one big list and then
    // process it at once. We are only looking at local archive storage because browsers should
    // be saving the txs that are addressed to them (i.e. notifications), but we can easily expand this
    // logic to also query remote sources (by changing return_count to the 2x number of peers)
    //
  }, {
    key: "loadNotifications",
    value: function loadNotifications() {
      var _this7 = this;
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var notifications = [];
      var return_count = 0;

      //
      // This is the callback to process the returned tweets,
      // which we DONT want to just insert into the feed
      //
      var middle_callback = function middle_callback() {
        var new_notifications = [];
        console.info("RS.loadNotifications: process ".concat(notifications.length, " combined tweet and like notifications"));
        if (notifications.length > 0) {
          for (var z = 0; z < notifications.length; z++) {
            notifications[z].decryptMessage(_this7.app);
            if (_this7.addNotification(notifications[z])) {
              new_notifications.push(notifications[z]);
            }
          }
        } else {
          console.info('RS.loadNotifications: last notification fetch returned nothing');
          _this7.notifications_earliest_ts = 0;
        }
        console.info("RS.loadNotifications: Appending ".concat(new_notifications.length, " new notification notices to the page"));
        if (mycallback) {
          mycallback(new_notifications);
        }
      };
      if (this.notifications_earliest_tweet_ts) {
        return_count++;

        //if (this.debug) {
        console.debug("RS.loadNotifications: query tweet notifications");
        // }

        this.app.storage.loadTransactions({
          field1: 'RedSquare',
          field3: this.publicKey,
          created_earlier_than: this.notifications_earliest_tweet_ts
        }, function (txs) {
          var _iterator5 = _createForOfIteratorHelper(txs),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var tx = _step5.value;
              if (tx.timestamp < _this7.notifications_earliest_tweet_ts) {
                _this7.notifications_earliest_tweet_ts = tx.timestamp;
              }
              notifications.push(tx);
            }

            //if (this.debug) {
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          console.debug("RS.loadNotifications: Found ".concat(txs.length, " tweets"));
          //}

          return_count--;
          if (return_count == 0) {
            middle_callback();
          } else {
            console.debug('Process tweets first!');
          }
        }, 'localhost');
      }
      if (this.notifications_earliest_like_ts) {
        return_count++;
        console.debug("RS.loadNotifications: query like notifications");

        //
        // Okay, so using a special like tag to make profile loading easier
        // complicates notifications loading... it would be nice if our arbitrary
        // archive fields weren't completely occupied by module/from/to...
        // This will need fixing if/when we change the archive schema (13 Nov 2023)
        //
        this.app.storage.loadTransactions({
          field1: 'RedSquareLike',
          field3: this.publicKey,
          created_earlier_than: this.notifications_earliest_like_ts
        }, function (txs) {
          var _iterator6 = _createForOfIteratorHelper(txs),
            _step6;
          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var tx = _step6.value;
              if (tx.timestamp < _this7.notifications_earliest_like_ts) {
                _this7.notifications_earliest_like_ts = tx.timestamp;
              }
              notifications.push(tx);
            }

            //if (this.debug) {
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }
          console.debug("RS.loadNotifications: Found ".concat(txs.length, " likes"));
          //}

          return_count--;
          if (return_count == 0) {
            middle_callback();
          }
        }, 'localhost');
      }
      if (!this.notifications_earliest_like_ts && !this.notifications_earliest_tweet_ts) {
        //
        // Just return empty array if we don't query the peers again
        //
        if (mycallback) {
          mycallback([]);
        }
      }
    }
  }, {
    key: "loadTweetThread",
    value: function loadTweetThread(thread_id) {
      var _this8 = this;
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!mycallback) {
        return;
      }
      siteMessage("Checking peers for more replies...", 1000);
      var peer_count = this.peers.length;
      var _loop2 = function _loop2(j) {
        if (_this8.peers[j].peer !== 'localhost') {
          _this8.app.network.sendRequestAsTransaction('load thread', {
            sig: thread_id
          }, function (txs) {
            console.log('Thread tweets loaded: ', txs.length);
            for (var i = 0; i < txs.length; i++) {
              var tx = new Transaction();
              tx.deserialize_from_web(_this8.app, txs[i]);
              tx.decryptMessage(_this8.app);
              _this8.addTweet(tx, {
                type: 'tweet_thread',
                node: _this8.peers[j].publicKey
              });
            }
            peer_count--;
            if (peer_count == 0) {
              // Validate reply counts
              _this8.validateThread(thread_id);

              // Run callback (to render thread)
              mycallback(txs);
            }
          }, _this8.peers[j].peer.publicKey);
        } else {
          peer_count--;
        }
      };
      for (var j = 0; j < this.peers.length; j++) {
        _loop2(j);
      }
    }

    //
    // Prioritize looking for the specific tweet
    // 1) in my tweet list
    // 2) in my local archive
    // 3) in my peer archives
    //  It would be useful if we could convert everything to async and have a return value
    //  so that we can avoid callback hell when we really want to get that tweet to process something on it
    //
  }, {
    key: "loadTweetWithSig",
    value: function loadTweetWithSig(sig) {
      var _this9 = this;
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var redsquare_self = this;
      if (mycallback == null) {
        return;
      }
      var t = this.returnTweet(sig);
      if (t != null) {
        mycallback([t.tx]);
        return;
      }
      this.app.storage.loadTransactions({
        sig: sig,
        field1: 'RedSquare'
      }, function (txs) {
        if (txs.length > 0) {
          for (var z = 0; z < txs.length; z++) {
            txs[z].decryptMessage(_this9.app);
            _this9.addTweet(txs[z], {
              type: 'loadTweetWithSig',
              node: 'localhost'
            });
          }
          mycallback(txs);
        } else {
          var _loop3 = function _loop3(i) {
            if (_this9.peers[i].publicKey !== _this9.publicKey) {
              _this9.app.storage.loadTransactions({
                sig: sig,
                field1: 'RedSquare'
              }, function (txs) {
                if (txs.length > 0) {
                  for (var _z = 0; _z < txs.length; _z++) {
                    txs[_z].decryptMessage(_this9.app);
                    _this9.addTweet(txs[_z], {
                      type: 'loadTweetWithSig',
                      node: _this9.peers[i].publicKey
                    });
                  }
                  mycallback(txs);
                } else {
                  console.error("Couldn't find tweet with sig: " + sig + ' on local or remote archives');
                }
              }, _this9.peers[i].peer);
            }
          };
          for (var i = 0; i < _this9.peers.length; i++) {
            _loop3(i);
          }
        }
      }, 'localhost');
    }

    ///////////////
    // add tweet //
    ///////////////
    //
    // this creates the tweet and adds it to the internal list that we maintain of
    // the tweets that holds them in a structured tree (parents hold children, etc.)
    // while also maintaining a separate list of the notifications, etc. this function
    // also indexes the tweets as needed in the various hashmaps so they can be
    // retrieved by returnTweet()
    //
    // this does not DISPLAY any tweets, although it makes sure that when they are
    // added they will render into the TWEET MANAGER component.
    //
    // returns 1 if this is a new tweet that can be displayed
    //
  }, {
    key: "addTweet",
    value: function addTweet(tx) {
      var _tweet;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var override_curation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      //
      // if this is a like or flag tx, it isn't anything to add to the feed so stop here
      //
      var txmsg = tx.returnMessage();
      if (source) {
        source.ts = new Date().getTime();
        if (tx.optional) {
          source.optional = Object.assign({}, tx.optional);
        }
      }
      if (txmsg.request === 'like tweet' || txmsg.request === 'flag tweet' || txmsg.request === 'retweet') {
        if (this.debug) {
          console.debug("RS.addTweet -- Don't process " + txmsg.request);
        }
        return 0;
      }
      if (txmsg.request === 'delete tweet' && this.app.BROWSER) {
        if (this.debug) {
          console.debug('RS.addTweet -- process ' + txmsg.request);
        }
        this.receiveDeleteTransaction(0, tx, 0, this.app);
        return 0;
      }
      if (txmsg.request === 'edit tweet') {
        if (this.debug) {
          console.debug('RS.addTweet -- process ' + txmsg.request);
        }
        this.editTweet(txmsg.data.tweet_id, tx, source);
        return 0;
      }

      //
      // we may be attempting to add a tweet that we already have in our hashmap, in
      // this case we want to load our existing tweet and update the stats for it that
      // already exist in our memory, such as updated an edited version of the text.
      // once we have updated the tweet information, we can optionally signal whether
      // we want to re-render it.
      //
      if (this.tweets_sigs_hmap[tx.signature]) {
        var t = this.returnTweet(tx.signature);
        if (!t) {
          console.warn('RS.addTweet: tweet in hmap by not returned...');
          console.debug(txmsg);
          return 0;
        }
        if (this.debug) {
          console.debug("RS.addTweet: Duplicate! Feed length: (".concat(this.tweets.length, ") -- "), t === null || t === void 0 ? void 0 : t.text, source // includes stats from the new tx
          );
        }

        //
        // We push this additional source for record keeping
        //
        t.sources.push(source);
        if (tx.optional) {
          var should_rerender = false;
          if (tx.optional.num_replies > t.tx.optional.num_replies) {
            t.tx.optional.num_replies = tx.optional.num_replies;
          }
          if (tx.optional.num_retweets > t.tx.optional.num_retweets) {
            t.tx.optional.num_retweets = tx.optional.num_retweets;
            t.tx.optional.retweeters = tx.optional.retweeters;
            should_rerender = true;
          }
          if (tx.optional.num_likes > t.tx.optional.num_likes) {
            t.tx.optional.num_likes = tx.optional.num_likes;
          }
          if (tx.optional.update_tx) {
            t.tx.optional.update_tx = tx.optional.update_tx;
            should_rerender = true;
          }
          var tx_updated_at = tx.optional.updated_at || tx.timestamp;
          if (tx_updated_at > t.updated_at) {
            t.updated_at = Math.max(t.updated_at, tx_updated_at);
            should_rerender = true;
            if (tx.optional.link_properties) {
              t.tx.optional.link_properties = tx.optional.link_properties;
            }
          }
          t.tx.optional.updated_at = tx.optional.updated_at;
          if (tx.optional.curated && !t.curated) {
            // Update curation value if (1/-1)
            t.tx.optional.curated = tx.optional.curated;
            t.curated = tx.optional.curated;
            delete t.curation_check;
            if (tx.optional.curation_check !== 'undefined') {
              t.tx.optional.curation_check = tx.optional.curation_check;
            }
            should_rerender = true;
          }
          t.rerenderControls(should_rerender);

          //this.updateSavedTweet(tx.signature);
        }
        return 0;
      }

      //
      // create the tweet
      //
      var tweet = new Tweet(this.app, this, tx);
      if (!((_tweet = tweet) !== null && _tweet !== void 0 && _tweet.tx)) {
        console.warn('RS.addTweet -- Created a tweet with a null tx');
        return 0;
      }
      if (source.type == 'tweet_thread') {
        console.log('Add thread tweet', tweet.tx.signature, tweet.text);
      }

      //
      // This should be the first, primary source
      //
      tweet.sources.push(source);

      //
      // curation: accept the curated parameter if 1, or fallback on algorithmic curation
      //
      tweet.curated = override_curation || this.curate(tx);
      // So we don't lose our curation if rerendering tweet after an archival pull
      tweet.tx.optional.curated = tweet.curated;
      if (tweet.curation_check) {
        if (tweet.curated == 1) {
          console.log('We already accept the tweet to test!');
          delete tweet.curation_check;
          delete tweet.tx.optional.curation_check;
        }
      }

      //
      // new tweet added, so we gives modules freedom-to-annotate
      //
      var _iterator7 = _createForOfIteratorHelper(this.app.modules.respondTo('redsquare-add-tweet')),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var xmod = _step7.value;
          tweet = xmod.respondTo('redsquare-add-tweet').processTweet(tweet);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
      if (tweet.rethread) {
        //
        // Flag tweet as rethread and null thread_id --> do not display!
        //
        if (!tweet.thread_id) {
          if (this.debug) {
            console.debug('RS.addTweet -- ignore marked tweet');
          }

          // I am not sure we need to mark this as such...
          // it does lead to a bunch more warnings in the logs down the way
          //this.tweets_sigs_hmap[tweet.tx.signature] = 2;
          return 0;
        }

        //
        //  keep track of list of special threads
        //
        if (this.special_threads_hmap[tweet.thread_id]) {
          if (this.debug) {
            var _tweet2;
            console.debug('RS.addTweet -- inserting marked tweet into existing thread', (_tweet2 = tweet) === null || _tweet2 === void 0 ? void 0 : _tweet2.thread_id);
          }
          for (var i = 0; i < this.tweets.length; i++) {
            if (this.tweets[i].thread_id == tweet.thread_id) {
              this.tweets_sigs_hmap[tweet.tx.signature] = 1;
              if (tweet.created_at > this.tweets[i].created_at) {
                this.tweets[i].parent_id = tweet.tx.signature;
                var should_render = this.tweets[i].isRendered();
                this.tweets[i].remove();
                tweet.addTweet(this.tweets[i]);
                if (should_render) {
                  tweet.render(true);
                }
                this.tweets.splice(i, 1);
                var insertion_index = 0;
                for (var j = 0; i < this.tweets.length; i++) {
                  if (this.tweets[j].created_at > tweet.created_at) {
                    insertion_index++;
                  } else {
                    this.out_of_order = true;
                    break;
                  }
                }
                this.tweets.splice(insertion_index, 0, tweet);
              } else {
                tweet.parent_id = this.tweets[i].tx.signature;
                this.tweets[i].addTweet(tweet);
                this.tweets[i].rerenderControls(true);
              }
              return -1;
            }
          }
          console.warn('RS.addTweet -- Thread not found! Not adding special tweet to feed');
          return 0;
        }
        if (this.debug) {
          var _tweet3;
          console.debug('RS.addTweet -- new special tweet thread', (_tweet3 = tweet) === null || _tweet3 === void 0 ? void 0 : _tweet3.thread_id);
        }
        this.special_threads_hmap[tweet.thread_id] = 1;

        // Insert as normal
      }

      //
      // tweets are displayed in chronological order
      //
      if (!tweet.parent_id) {
        var _insertion_index = 0;
        for (var _i2 = 0; _i2 < this.tweets.length; _i2++) {
          if (this.tweets[_i2].created_at > tweet.created_at) {
            _insertion_index++;
          } else {
            this.out_of_order = true;
            break;
          }
        }
        this.tweets.splice(_insertion_index, 0, tweet);
        this.tweets_sigs_hmap[tweet.tx.signature] = 1;
        for (var _i3 = 0; _i3 < this.unknown_children.length; _i3++) {
          if (this.unknown_children[_i3].thread_id === tweet.tx.signature) {
            tweet.addTweet(this.unknown_children[_i3]);
            this.unknown_children.splice(_i3, 1);
            _i3--;
          }
        }
        if (this.debug) {
          console.debug("\n===\nRS.addTweet Success! Feed has (".concat(this.tweets.length, ") -- "), tweet.text.substring(0, 50), source.node, "Curated: ".concat(tweet.curated));
        }
        return 1;

        //
        // this is a comment / reply
        //
        // we find the tweet that is the parent and push it into the array
        // at that point. otherwise, we mark it as an unknown_child which
        // means we know it HAS a parent but we do not -- as of yet -- have
        // a copy of that tweet.
        //
      } else {
        for (var _i4 = 0; _i4 < this.tweets.length; _i4++) {
          if (this.tweets[_i4].tx.signature === tweet.thread_id) {
            this.tweets[_i4].addTweet(tweet);
            this.tweets_sigs_hmap[tweet.tx.signature] = 1;
            if (this.debug) {
              console.debug("RS.addTweet: child tweet success! Feed length: (".concat(this.tweets.length, ") -- "), tweet.text, source);
            }
            return -1;
          }
        }
        this.unknown_children.push(tweet);
        this.tweets_sigs_hmap[tweet.tx.signature] = 1;
        if (this.debug) {
          console.debug("RS.addTweet: unknown child! Feed length: (".concat(this.tweets.length, ") -- "), tweet.text, source);
        }
        return -1;
      }
    }

    //
    // addTweets adds notifications, but we have a separate function here
    // for cached notifications, because we don't want to show all of the
    // cached notifications in the main thread automatically, and we want a
    // dedicated function that tells us if this notification is new or not
    //
  }, {
    key: "addNotification",
    value: function addNotification(tx) {
      if (tx.isTo(this.publicKey)) {
        if (!tx.isFrom(this.publicKey)) {
          //
          // only insert notification if doesn't already exist
          //
          if (this.notifications_sigs_hmap[tx.signature] != 1) {
            if (this.debug) {
              console.debug('RS.addNotification', tx.msg, tx.timestamp);
            }
            var insertion_index = 0;
            for (var i = 0; i < this.notifications.length; i++) {
              if (tx.timestamp > this.notifications[i].timestamp) {
                break;
              } else {
                insertion_index++;
              }
            }
            this.notifications.splice(insertion_index, 0, tx);
            this.notifications_sigs_hmap[tx.signature] = 1;
            if (tx.timestamp > this.notifications_last_viewed_ts) {
              this.notifications_number_unviewed = this.notifications_number_unviewed + 1;
              this.app.connection.emit('redsquare-update-notifications', this.notifications_number_unviewed);
            }
            this.saveOptions();
            return 1;
          } else {
            console.debug('RS.addNotification duplicate notification');
          }
        }
      }
      return 0;
    }
  }, {
    key: "resetNotifications",
    value: function resetNotifications() {
      this.notifications_last_viewed_ts = new Date().getTime();
      this.notifications_number_unviewed = 0;
      this.saveOptions();
      this.app.connection.emit('redsquare-update-notifications', this.notifications_number_unviewed);
    }
  }, {
    key: "returnTweet",
    value: function returnTweet() {
      var tweet_sig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (tweet_sig == null) {
        return null;
      }
      if (!this.tweets_sigs_hmap[tweet_sig] && !this.special_threads_hmap[tweet_sig]) {
        return null;
      }
      for (var i = 0; i < this.tweets.length; i++) {
        if (this.tweets[i].tx.signature === tweet_sig) {
          return this.tweets[i];
        }
        if (this.tweets[i].hasChildTweet(tweet_sig)) {
          return this.tweets[i].returnChildTweet(tweet_sig);
        }

        // special thread_ids...
        if (this.tweets[i].thread_id === tweet_sig) {
          return this.tweets[i];
        }
      }
      for (var j = 0; j < this.unknown_children.length; j++) {
        if (this.unknown_children[j].tx.signature === tweet_sig) {
          return this.unknown_children[j];
        }
      }
      return null;
    }
  }, {
    key: "removeTweet",
    value: function removeTweet() {
      var tweet_sig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!tweet_sig || !this.tweets_sigs_hmap[tweet_sig]) {
        return;
      }
      this.tweets_sigs_hmap[tweet_sig] = 0;
      for (var i = 0; i < this.tweets.length; i++) {
        if (this.tweets[i].tx.signature === tweet_sig) {
          this.tweets[i].remove();
          this.tweets.splice(i, 1);
          return;
        }
        if (this.tweets[i].hasChildTweet(tweet_sig)) {
          this.tweets[i].removeChildTweet(tweet_sig);
          return;
        }
      }
      for (var j = 0; j < this.unknown_children.length; j++) {
        if (this.unknown_children[j].tx.signature === tweet_sig) {
          this.unknown_children.splice(j, 1);
          return;
        }
      }
    }
  }, {
    key: "pruneTweets",
    value: function pruneTweets() {
      this.unknown_children = [];
      var pruned = [];
      var count = 0;
      if (this.tweets.length > 100) {
        for (var i = 0; count < 90 && i < this.tweets.length; i++) {
          if (this.tweets[i].curated == 1) {
            pruned.push(this.tweets[i]);
            count++;
          }
        }
      }
      this.tweets = pruned;
    }
  }, {
    key: "returnNotification",
    value: function returnNotification() {
      var tweet_sig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (tweet_sig == null) {
        return null;
      }
      if (!this.notifications_sigs_hmap[tweet_sig]) {
        return null;
      }
      for (var i = 0; i < this.notifications.length; i++) {
        if (this.notifications[i].signature === tweet_sig) {
          return this.notifications[i];
        }
      }
      return null;
    }
  }, {
    key: "returnThreadSigs",
    value: function returnThreadSigs(tweet_id) {
      var sigs = [];
      while (tweet_id) {
        var tweet = this.returnTweet(tweet_id);
        if (!tweet) {
          console.warn('Incomplete tweet thread!');
          return sigs;
        }
        sigs.push(tweet_id);
        tweet_id = tweet.parent_id;
      }
      return sigs;
    }
  }, {
    key: "validateThread",
    value: function validateThread(tweet_id) {
      var tweet = this.returnTweet(tweet_id);
      if (tweet) {
        if (tweet.num_replies !== tweet.children.length) {
          console.debug("manually correct reply count: ".concat(tweet.num_replies, " -> ").concat(tweet.children.length));
          tweet.tx.optional.num_replies = tweet.children.length;
          tweet.num_replies = tweet.children.length;

          // Make sure the tweet in the main thread updates its reply count too
          // refreshStat fixes the stat for the tweet anywhere (even hidden) on the page
          tweet.refreshStat('comment', tweet.num_replies);
        }
        var _iterator8 = _createForOfIteratorHelper(tweet.children),
          _step8;
        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var child = _step8.value;
            this.validateThread(child.tx.signature);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }
      }
    }

    ///////////////////////
    // network functions //
    ///////////////////////
  }, {
    key: "sendLikeTransaction",
    value: function () {
      var _sendLikeTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(app, mod, data, tx) {
        var _tx$from$;
        var redsquare_self, obj, key, newtx, i;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              redsquare_self = this;
              obj = {
                module: redsquare_self.name,
                request: 'like tweet',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context7.n = 1;
              return redsquare_self.app.wallet.createUnsignedTransaction((_tx$from$ = tx.from[0]) === null || _tx$from$ === void 0 ? void 0 : _tx$from$.publicKey);
            case 1:
              newtx = _context7.v;
              //
              // All tweets include the sender in the to, but add the from first so they are in first position
              //
              for (i = 0; i < tx.to.length; i++) {
                if (tx.to[i].publicKey !== this.publicKey) {
                  newtx.addTo(tx.to[i].publicKey);
                }
              }
              newtx.msg = obj;
              _context7.n = 2;
              return newtx.sign();
            case 2:
              _context7.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context7.a(2, newtx);
          }
        }, _callee7, this);
      }));
      function sendLikeTransaction(_x1, _x10, _x11, _x12) {
        return _sendLikeTransaction.apply(this, arguments);
      }
      return sendLikeTransaction;
    }()
  }, {
    key: "addToCouncil",
    value: function addToCouncil(key) {
      var trust_rating = this.jedi_council.has(key) ? this.jedi_council.get(key) : 0;
      trust_rating++;
      this.jedi_council.set(key, trust_rating);
      if (trust_rating > 12) {
        this.app.connection.emit('saito-whitelist', {
          publicKey: key
        });
      }
    }
  }, {
    key: "updateTweetCuration",
    value: function updateTweetCuration(tweet, interaction_tx) {
      //
      // set as curated if liked by moderator, but ignore blacklisted people
      //
      var new_curation = Math.max(0, this.curate(interaction_tx));
      if (new_curation == 1) {
        //console.debug('RS move tweet to curated by trusted like/retweet!');
        this.addToCouncil(tweet.tx.from[0].publicKey);
      }
      tweet.curated = new_curation || tweet.curated;
    }
  }, {
    key: "updateTweetStat",
    value: function () {
      var _updateTweetStat = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(tweet_tx, ts, stat) {
        var _this0 = this;
        var tweet,
          tweet_ts,
          obj,
          _args8 = arguments;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              tweet = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : null;
              if (!tweet_tx.optional) {
                tweet_tx.optional = {};
              }
              if (!tweet_tx.optional[stat]) {
                tweet_tx.optional[stat] = 0;
              }
              tweet_ts = (tweet === null || tweet === void 0 ? void 0 : tweet.updated_at) || tweet_tx.optional.updated_at || tweet_tx.timestamp;
              if (!(ts > tweet_ts)) {
                _context8.n = 2;
                break;
              }
              tweet_tx.optional[stat]++;

              //
              // Adjust the updated_at field in memory (already set in archive via update tx above)
              //
              if (!tweet) {
                _context8.n = 1;
                break;
              }
              tweet.potential_new_ts = Math.max(ts, tweet_ts, tweet.potential_new_ts || 0);
              if (tweet.timeout) {
                clearTimeout(tweet.timeout);
              }
              tweet.timeout = setTimeout(function () {
                _this0.app.storage.updateTransaction(tweet_tx, {
                  updated_at: tweet.potential_new_ts
                }, 'localhost');
                tweet.updated_at = tweet.potential_new_ts;
                delete tweet.timeout;
                delete tweet.potential_new_ts;
              }, 2000);
              _context8.n = 2;
              break;
            case 1:
              obj = {
                updated_at: ts
              };
              _context8.n = 2;
              return this.app.storage.updateTransaction(tweet_tx, obj, 'localhost');
            case 2:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function updateTweetStat(_x13, _x14, _x15) {
        return _updateTweetStat.apply(this, arguments);
      }
      return updateTweetStat;
    }()
  }, {
    key: "receiveLikeTransaction",
    value: function () {
      var _receiveLikeTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(blk, tx, conf, app) {
        var _this1 = this;
        var txmsg, liked_tweet;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              txmsg = tx.returnMessage();
              liked_tweet = this.returnTweet(txmsg.data.signature); //console.debug('Receive like transaction', tx.timestamp, liked_tweet?.text);
              //
              // save optional likes
              //
              if (!(liked_tweet !== null && liked_tweet !== void 0 && liked_tweet.tx)) {
                _context0.n = 2;
                break;
              }
              this.updateTweetCuration(liked_tweet, tx);
              _context0.n = 1;
              return this.updateTweetStat(liked_tweet.tx, tx.timestamp, 'num_likes', liked_tweet);
            case 1:
              liked_tweet.rerenderControls();
              _context0.n = 3;
              break;
            case 2:
              if (this.app.BROWSER) {
                _context0.n = 3;
                break;
              }
              _context0.n = 3;
              return this.app.storage.loadTransactions({
                sig: txmsg.data.signature,
                field1: 'RedSquare'
              }, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(txs) {
                  var tweet;
                  return _regenerator().w(function (_context9) {
                    while (1) switch (_context9.n) {
                      case 0:
                        if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                          _context9.n = 1;
                          break;
                        }
                        // Keep this in our memory...
                        _this1.addTweet(txs[0], {
                          type: 'on_chain_like',
                          node: 'localhost'
                        }, Math.max(0, _this1.curate(tx)));
                        tweet = _this1.returnTweet(txs[0].signature);
                        if (!tweet) {
                          _context9.n = 1;
                          break;
                        }
                        _context9.n = 1;
                        return _this1.updateTweetStat(tweet.tx, tx.timestamp, 'num_likes', tweet);
                      case 1:
                        return _context9.a(2);
                    }
                  }, _callee9);
                }));
                return function (_x20) {
                  return _ref.apply(this, arguments);
                };
              }(), 'localhost');
            case 3:
              _context0.n = 4;
              return this.app.storage.saveTransaction(tx, {
                field1: 'RedSquareLike'
              }, 'localhost', blk);
            case 4:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function receiveLikeTransaction(_x16, _x17, _x18, _x19) {
        return _receiveLikeTransaction.apply(this, arguments);
      }
      return receiveLikeTransaction;
    }()
  }, {
    key: "sendRetweetTransaction",
    value: function () {
      var _sendRetweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(app, mod, data, tx) {
        var _tx$from$2;
        var redsquare_self, obj, key, newtx, i;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              redsquare_self = this;
              obj = {
                module: redsquare_self.name,
                request: 'retweet',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context1.n = 1;
              return redsquare_self.app.wallet.createUnsignedTransaction((_tx$from$2 = tx.from[0]) === null || _tx$from$2 === void 0 ? void 0 : _tx$from$2.publicKey);
            case 1:
              newtx = _context1.v;
              //
              // All tweets include the sender in the to, but add the from first so they are in first position
              //
              for (i = 0; i < tx.to.length; i++) {
                if (tx.to[i].publicKey !== this.publicKey) {
                  newtx.addTo(tx.to[i].publicKey);
                }
              }
              // Make sure I am also a recipient
              newtx.addTo(this.publicKey);
              newtx.msg = obj;
              _context1.n = 2;
              return newtx.sign();
            case 2:
              _context1.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context1.a(2, newtx);
          }
        }, _callee1, this);
      }));
      function sendRetweetTransaction(_x21, _x22, _x23, _x24) {
        return _sendRetweetTransaction.apply(this, arguments);
      }
      return sendRetweetTransaction;
    }()
  }, {
    key: "incrementRetweets",
    value: function () {
      var _incrementRetweets = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(localTx, receivedTx) {
        var localTx_updated_at;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (!localTx.optional) {
                localTx.optional = {};
              }
              if (!localTx.optional.num_retweets) {
                localTx.optional.num_retweets = 0;
              }
              if (!localTx.optional.retweeters) {
                localTx.optional.retweeters = [];
              }
              localTx_updated_at = localTx.updated_at || localTx.timestamp;
              if (!(receivedTx.timestamp > localTx_updated_at)) {
                _context10.n = 2;
                break;
              }
              localTx.optional.num_retweets++;
              if (!localTx.optional.retweeters.includes(receivedTx.from[0].publicKey)) {
                localTx.optional.retweeters.unshift(receivedTx.from[0].publicKey);
              }
              localTx.optional.retweeted_at = receivedTx.timestamp;
              _context10.n = 1;
              return this.app.storage.updateTransaction(localTx, {
                updated_at: receivedTx.timestamp
              }, 'localhost');
            case 1:
              _context10.n = 3;
              break;
            case 2:
              console.warn('RS.incrementRetweets: transaction received after archive load', localTx, receivedTx);
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function incrementRetweets(_x25, _x26) {
        return _incrementRetweets.apply(this, arguments);
      }
      return incrementRetweets;
    }()
  }, {
    key: "receiveRetweetTransaction",
    value: function () {
      var _receiveRetweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(blk, tx, conf, app) {
        var _this10 = this;
        var txmsg, retweeted_tweet, i;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              txmsg = tx.returnMessage();
              retweeted_tweet = this.returnTweet(txmsg.data.signature); //
              // save optional likes
              //
              if (!(retweeted_tweet !== null && retweeted_tweet !== void 0 && retweeted_tweet.tx)) {
                _context12.n = 5;
                break;
              }
              _context12.n = 1;
              return this.incrementRetweets(retweeted_tweet.tx, tx);
            case 1:
              //
              // set as curated if liked by moderator
              //
              this.updateTweetCuration(retweeted_tweet, tx);
              retweeted_tweet.rerenderControls(true);

              ///
              ///>>> move to top of tweet list...
              ///
              i = 0;
            case 2:
              if (!(i < this.tweets.length)) {
                _context12.n = 4;
                break;
              }
              if (!(this.tweets[i].tx.signature == retweeted_tweet.tx.signature)) {
                _context12.n = 3;
                break;
              }
              this.tweets.splice(i, 1);
              return _context12.a(3, 4);
            case 3:
              i++;
              _context12.n = 2;
              break;
            case 4:
              this.tweets.unshift(retweeted_tweet);
              _context12.n = 6;
              break;
            case 5:
              _context12.n = 6;
              return this.app.storage.loadTransactions({
                sig: txmsg.data.signature,
                field1: 'RedSquare'
              }, /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(txs) {
                  return _regenerator().w(function (_context11) {
                    while (1) switch (_context11.n) {
                      case 0:
                        if ((txs === null || txs === void 0 ? void 0 : txs.length) > 0) {
                          _this10.incrementRetweets(txs[0], tx);
                        } else {
                          console.warn('RS.receiveRetweet: Original tweet not found');
                        }
                      case 1:
                        return _context11.a(2);
                    }
                  }, _callee11);
                }));
                return function (_x31) {
                  return _ref2.apply(this, arguments);
                };
              }(), 'localhost');
            case 6:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function receiveRetweetTransaction(_x27, _x28, _x29, _x30) {
        return _receiveRetweetTransaction.apply(this, arguments);
      }
      return receiveRetweetTransaction;
    }()
  }, {
    key: "sendEditTransaction",
    value: function () {
      var _sendEditTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(app, mod, data) {
        var keys,
          redsquare_self,
          obj,
          key,
          newtx,
          i,
          _args13 = arguments;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              keys = _args13.length > 3 && _args13[3] !== undefined ? _args13[3] : [];
              redsquare_self = this;
              obj = {
                module: redsquare_self.name,
                request: 'edit tweet',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context13.n = 1;
              return redsquare_self.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context13.v;
              newtx.msg = obj;
              for (i = 0; i < keys.length; i++) {
                newtx.addTo(keys[i]);
              }
              _context13.n = 2;
              return newtx.sign();
            case 2:
              _context13.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context13.a(2, newtx);
          }
        }, _callee13, this);
      }));
      function sendEditTransaction(_x32, _x33, _x34) {
        return _sendEditTransaction.apply(this, arguments);
      }
      return sendEditTransaction;
    }()
  }, {
    key: "sendDeleteTransaction",
    value: function () {
      var _sendDeleteTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(app, mod, data) {
        var keys,
          redsquare_self,
          obj,
          key,
          newtx,
          i,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              keys = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : [];
              redsquare_self = this;
              obj = {
                module: redsquare_self.name,
                request: 'delete tweet',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context14.n = 1;
              return redsquare_self.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context14.v;
              newtx.msg = obj;
              for (i = 0; i < keys.length; i++) {
                newtx.addTo(keys[i]);
              }
              _context14.n = 2;
              return newtx.sign();
            case 2:
              _context14.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context14.a(2, newtx);
          }
        }, _callee14, this);
      }));
      function sendDeleteTransaction(_x35, _x36, _x37) {
        return _sendDeleteTransaction.apply(this, arguments);
      }
      return sendDeleteTransaction;
    }()
  }, {
    key: "sendTweetTransaction",
    value: function () {
      var _sendTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(app, mod, data) {
        var keys,
          redsquare_self,
          obj,
          key,
          newtx,
          i,
          _args15 = arguments;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              keys = _args15.length > 3 && _args15[3] !== undefined ? _args15[3] : [];
              redsquare_self = this;
              obj = {
                module: redsquare_self.name,
                request: 'create tweet',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }

              //let wallet_balance = await this.app.wallet.getBalance('SAITO');

              //let amount_to_send = /*wallet_balance > 1 ? BigInt(1) :*/ BigInt(0);
              _context15.n = 1;
              return redsquare_self.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context15.v;
              newtx.msg = obj;
              for (i = 0; i < keys.length; i++) {
                if (keys[i] !== this.publicKey) {
                  newtx.addTo(keys[i]);
                }
              }
              _context15.n = 2;
              return newtx.sign();
            case 2:
              _context15.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context15.a(2, newtx);
          }
        }, _callee15, this);
      }));
      function sendTweetTransaction(_x38, _x39, _x40) {
        return _sendTweetTransaction.apply(this, arguments);
      }
      return sendTweetTransaction;
    }()
    /**
     *  @param tweet_id : transaction signature of the tweet to edit
     *  @param tx: edit tweet transaction with new message
     *  @param source: where we found this edit tweet tx
     *
     *  If the tweet-to-edit is in memory, we save the edit tx and ts in the tweet-to-edit's original
     *  tx iff this is the most recent edit.
     *
     *  Create a new Tweet with the updated original tx, which will automatically replace the text and add
     *  markup to show when the tweet was edited
     *
     *  Otherwise, save it as an "orphan"
     */
  }, {
    key: "editTweet",
    value: function editTweet(tweet_id, tx, source) {
      var edited_tweet = this.returnTweet(tweet_id);
      if (edited_tweet) {
        var _orig_tx$optional;
        var orig_tx = edited_tweet.tx;
        if (!orig_tx.optional) {
          orig_tx.optional = {};
        }

        // What if there are multiple edits?
        if (tx.timestamp > (((_orig_tx$optional = orig_tx.optional) === null || _orig_tx$optional === void 0 ? void 0 : _orig_tx$optional.edit_ts) || 0)) {
          orig_tx.optional.update_tx = tx.serialize_to_web(this.app);
          orig_tx.optional.edit_ts = tx.timestamp;

          // To-Do -- shouldn't we replace the tweet?
          var new_tweet = new Tweet(this.app, this, orig_tx, edited_tweet.container);

          //
          // Information on the edit becomes part of the source history...
          //
          new_tweet.sources.push(source);
          //
          // update keys from (optional) and completely rerender
          //
          new_tweet.rerenderControls(true);
        }
      } else {
        this.orphan_edits.push({
          tweet_id: tweet_id,
          tx: tx,
          source: source
        });
      }
    }
  }, {
    key: "receiveEditTransaction",
    value: function () {
      var _receiveEditTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(blk, tx, conf, app) {
        var _this11 = this;
        var _txmsg$data, txmsg, _t2;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              _context17.p = 0;
              txmsg = tx.returnMessage();
              if ((_txmsg$data = txmsg.data) !== null && _txmsg$data !== void 0 && _txmsg$data.tweet_id) {
                _context17.n = 1;
                break;
              }
              console.warn('RS.receiveEdit: no tweet id to edit');
              return _context17.a(2);
            case 1:
              console.info('RS.receiveEdit: transaction received');

              // See above
              this.editTweet(txmsg.data.tweet_id, tx, "onchain-edit-".concat(tx.from[0].publicKey));
              _context17.n = 2;
              return this.app.storage.loadTransactions({
                sig: txmsg.data.tweet_id,
                field1: 'RedSquare'
              }, /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(txs) {
                  var oldtx, _oldtx$optional;
                  return _regenerator().w(function (_context16) {
                    while (1) switch (_context16.n) {
                      case 0:
                        if (!(txs !== null && txs !== void 0 && txs.length)) {
                          _context16.n = 1;
                          break;
                        }
                        //
                        // only update first copy??
                        //
                        oldtx = txs[0]; //
                        // save the tx
                        //
                        if (!(oldtx.from[0].publicKey === tx.from[0].publicKey)) {
                          _context16.n = 1;
                          break;
                        }
                        if (!oldtx.optional) {
                          oldtx.optional = {};
                        }
                        if (tx.timestamp > (((_oldtx$optional = oldtx.optional) === null || _oldtx$optional === void 0 ? void 0 : _oldtx$optional.edit_ts) || 0)) {
                          oldtx.optional.update_tx = tx.serialize_to_web(_this11.app);
                          oldtx.optional.edit_ts = tx.timestamp;
                        }
                        _context16.n = 1;
                        return _this11.app.storage.updateTransaction(oldtx, {
                          updated_at: tx.timestamp
                        }, 'localhost');
                      case 1:
                        return _context16.a(2);
                    }
                  }, _callee16);
                }));
                return function (_x45) {
                  return _ref3.apply(this, arguments);
                };
              }(), 'localhost');
            case 2:
              _context17.n = 4;
              break;
            case 3:
              _context17.p = 3;
              _t2 = _context17.v;
            case 4:
              return _context17.a(2);
          }
        }, _callee17, this, [[0, 3]]);
      }));
      function receiveEditTransaction(_x41, _x42, _x43, _x44) {
        return _receiveEditTransaction.apply(this, arguments);
      }
      return receiveEditTransaction;
    }() //
    // We should remove the tweet in question from memory (if we have it)
    // remove it from the archives and update the archives of linked tweets so that the stats
    // decrement accordingly
    // To-do: implement live updating of reply/retweet counts (currently requires a refresh)
    //
  }, {
    key: "receiveDeleteTransaction",
    value: function () {
      var _receiveDeleteTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(blk, tx, conf, app) {
        var _this12 = this;
        var txmsg;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.n) {
            case 0:
              console.info('RS.receiveDelete: transaction received');
              txmsg = tx.returnMessage();
              if (txmsg.data) {
                _context21.n = 1;
                break;
              }
              return _context21.a(2);
            case 1:
              if (txmsg.data.tweet_id) {
                _context21.n = 2;
                break;
              }
              return _context21.a(2);
            case 2:
              this.removeTweet(txmsg.data.tweet_id);
              _context21.n = 3;
              return this.app.storage.loadTransactions({
                sig: txmsg.data.tweet_id
              }, /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(txs) {
                  var oldtx, tweet;
                  return _regenerator().w(function (_context20) {
                    while (1) switch (_context20.n) {
                      case 0:
                        if (!(txs !== null && txs !== void 0 && txs.length)) {
                          _context20.n = 3;
                          break;
                        }
                        //
                        // only update first copy??
                        //
                        oldtx = txs[0]; //
                        // save the tx
                        //
                        if (!(oldtx.from[0].publicKey === tx.from[0].publicKey)) {
                          _context20.n = 3;
                          break;
                        }
                        _context20.n = 1;
                        return _this12.app.storage.deleteTransaction(oldtx, {}, 'localhost');
                      case 1:
                        tweet = new Tweet(_this12.app, _this12, oldtx, ''); // Delete tweet is a reply
                        if (!tweet.tx.optional.parent_id) {
                          _context20.n = 2;
                          break;
                        }
                        _context20.n = 2;
                        return _this12.app.storage.loadTransactions({
                          sig: tweet.tx.optional.parent_id,
                          field1: 'RedSquare'
                        }, /*#__PURE__*/function () {
                          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(txs) {
                            var _txs$;
                            return _regenerator().w(function (_context18) {
                              while (1) switch (_context18.n) {
                                case 0:
                                  if (!(txs !== null && txs !== void 0 && txs.length)) {
                                    _context18.n = 1;
                                    break;
                                  }
                                  if (!((_txs$ = txs[0]) !== null && _txs$ !== void 0 && (_txs$ = _txs$.optional) !== null && _txs$ !== void 0 && _txs$.num_replies)) {
                                    _context18.n = 1;
                                    break;
                                  }
                                  txs[0].optional.num_replies--;
                                  _context18.n = 1;
                                  return _this12.app.storage.updateTransaction(txs[0], {
                                    updated_at: tx.timestamp
                                  }, 'localhost');
                                case 1:
                                  return _context18.a(2);
                              }
                            }, _callee18);
                          }));
                          return function (_x51) {
                            return _ref5.apply(this, arguments);
                          };
                        }(), 'localhost');
                      case 2:
                        if (!tweet.retweet_tx) {
                          _context20.n = 3;
                          break;
                        }
                        _context20.n = 3;
                        return _this12.app.storage.loadTransactions({
                          sig: tweet.retweet.tx.signature,
                          field1: 'RedSquare'
                        }, /*#__PURE__*/function () {
                          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(txs) {
                            var _txs$0$optional;
                            return _regenerator().w(function (_context19) {
                              while (1) switch (_context19.n) {
                                case 0:
                                  if (!(txs !== null && txs !== void 0 && txs.length)) {
                                    _context19.n = 1;
                                    break;
                                  }
                                  if (!((_txs$0$optional = txs[0].optional) !== null && _txs$0$optional !== void 0 && _txs$0$optional.num_retweets)) {
                                    _context19.n = 1;
                                    break;
                                  }
                                  txs[0].optional.num_retweets--;
                                  _context19.n = 1;
                                  return _this12.app.storage.updateTransaction(txs[0], {
                                    updated_at: tx.timestamp
                                  }, 'localhost');
                                case 1:
                                  return _context19.a(2);
                              }
                            }, _callee19);
                          }));
                          return function (_x52) {
                            return _ref6.apply(this, arguments);
                          };
                        }(), 'localhost');
                      case 3:
                        return _context20.a(2);
                    }
                  }, _callee20);
                }));
                return function (_x50) {
                  return _ref4.apply(this, arguments);
                };
              }(), 'localhost');
            case 3:
              if (app.BROWSER) {
                _context21.n = 4;
                break;
              }
              _context21.n = 4;
              return this.app.storage.saveTransaction(tx, {
                field1: 'RedSquare'
              }, 'localhost', blk);
            case 4:
              return _context21.a(2);
          }
        }, _callee21, this);
      }));
      function receiveDeleteTransaction(_x46, _x47, _x48, _x49) {
        return _receiveDeleteTransaction.apply(this, arguments);
      }
      return receiveDeleteTransaction;
    }()
  }, {
    key: "receiveTweetTransaction",
    value: function () {
      var _receiveTweetTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(blk, tx, conf, app) {
        var _this13 = this;
        var tweet, other_tweet, txmsg, _t3;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              console.info('##################\n#################\nRS.receiveTweet: transaction received');
              _context24.p = 1;
              tweet = new Tweet(app, this, tx);
              other_tweet = null;
              txmsg = tx.returnMessage(); //
              // save this transaction in our archives as a redsquare transaction that is owned by ME (the server), so that I
              // can deliver it to users who want to fetch RedSquare transactions from the archives instead of just through the
              // sql database -- this is done by specifying that I -- "localhost" am the peer required.
              //
              //
              // servers -- get open graph properties
              //
              _context24.n = 2;
              return tweet.analyseTweetLinks(1);
            case 2:
              tweet = _context24.v;
              this.saveTweet(tweet, 1, blk);

              //
              // Includes retweeted tweet
              //
              if (!(tweet.retweet_tx != null)) {
                _context24.n = 5;
                break;
              }
              other_tweet = this.returnTweet(tweet.signature);
              if (!other_tweet) {
                _context24.n = 4;
                break;
              }
              _context24.n = 3;
              return this.incrementRetweets(other_tweet.tx, tx);
            case 3:
              this.updateTweetCuration(other_tweet, tx);
              other_tweet.rerenderControls();
              _context24.n = 5;
              break;
            case 4:
              _context24.n = 5;
              return this.app.storage.loadTransactions({
                sig: tweet.signature,
                field1: 'RedSquare'
              }, /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(txs) {
                  return _regenerator().w(function (_context22) {
                    while (1) switch (_context22.n) {
                      case 0:
                        if (txs !== null && txs !== void 0 && txs.length) {
                          _this13.incrementRetweets(txs[0], tx);
                        }
                      case 1:
                        return _context22.a(2);
                    }
                  }, _callee22);
                }));
                return function (_x57) {
                  return _ref7.apply(this, arguments);
                };
              }(), 'localhost');
            case 5:
              if (!(tweet.parent_id && tweet.parent_id !== tweet.tx.signature)) {
                _context24.n = 8;
                break;
              }
              //
              // if we have the parent tweet in memory...
              //
              other_tweet = this.returnTweet(tweet.parent_id);
              if (!other_tweet) {
                _context24.n = 7;
                break;
              }
              _context24.n = 6;
              return this.updateTweetStat(other_tweet.tx, tx.timestamp, 'num_replies', other_tweet);
            case 6:
              other_tweet.rerenderControls();
              _context24.n = 8;
              break;
            case 7:
              _context24.n = 8;
              return this.app.storage.loadTransactions({
                sig: tweet.parent_id,
                field1: 'RedSquare'
              }, /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(txs) {
                  return _regenerator().w(function (_context23) {
                    while (1) switch (_context23.n) {
                      case 0:
                        if (!(txs !== null && txs !== void 0 && txs.length)) {
                          _context23.n = 1;
                          break;
                        }
                        _context23.n = 1;
                        return _this13.updateTweetStat(txs[0], tx.timestamp, 'num_replies');
                      case 1:
                        return _context23.a(2);
                    }
                  }, _callee23);
                }));
                return function (_x58) {
                  return _ref8.apply(this, arguments);
                };
              }(), 'localhost');
            case 8:
              _context24.n = 10;
              break;
            case 9:
              _context24.p = 9;
              _t3 = _context24.v;
            case 10:
              return _context24.a(2);
          }
        }, _callee24, this, [[1, 9]]);
      }));
      function receiveTweetTransaction(_x53, _x54, _x55, _x56) {
        return _receiveTweetTransaction.apply(this, arguments);
      }
      return receiveTweetTransaction;
    }() //
    // How does this work with the archive module???
    //
  }, {
    key: "sendFlagTransaction",
    value: function () {
      var _sendFlagTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(app, mod, data, tx) {
        var redsquare_self, obj, key, newtx;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              redsquare_self = this;
              obj = {
                module: redsquare_self.name,
                request: 'flag tweet',
                data: {}
              }; //
              // data = {signature : tx.signature }
              //
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context25.n = 1;
              return redsquare_self.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context25.v;
              newtx.msg = obj;
              _context25.n = 2;
              return newtx.sign();
            case 2:
              _context25.n = 3;
              return redsquare_self.app.network.propagateTransaction(newtx);
            case 3:
              return _context25.a(2, newtx);
          }
        }, _callee25, this);
      }));
      function sendFlagTransaction(_x59, _x60, _x61, _x62) {
        return _sendFlagTransaction.apply(this, arguments);
      }
      return sendFlagTransaction;
    }() //
    // We have a lot of work to do here....
    // ...an interface for users to delete their own tweets
    // ...an interface for moderators to review tweets
    //
  }, {
    key: "receiveFlagTransaction",
    value: function () {
      var _receiveFlagTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(blk, tx, conf, app) {
        var _this14 = this;
        var txmsg, flagged_tweet, process_action, modScore;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              txmsg = tx.returnMessage();
              flagged_tweet = this.returnTweet(txmsg.data.signature);
              process_action = tx.isFrom(this.publicKey);
              modScore = this.app.modules.moderate(tx);
              if (!(modScore == -1)) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2);
            case 1:
              if (modScore == 1) {
                // Trusted moderator
                process_action = true;
              }
            case 2:
              if (flagged_tweet) {
                // two people who are not moderators have flagged it
                if (flagged_tweet.flagged) {
                  process_action = true;
                } else {
                  // add a note that this was flagged, but don't necessarily update the database
                  flagged_tweet.flagged = true;
                }

                //Move off curation list
                flagged_tweet.curated = -1;
                flagged_tweet.optional.curated = -1;
                this.cacheRecentTweets(true);
              }

              //
              // we will "soft delete" the tweet for the person who flagged it and in the central archives
              //
              if (!process_action) {
                _context27.n = 5;
                break;
              }
              if (!(flagged_tweet !== null && flagged_tweet !== void 0 && flagged_tweet.tx)) {
                _context27.n = 4;
                break;
              }
              _context27.n = 3;
              return this.app.storage.updateTransaction(flagged_tweet.tx, {
                updated_at: tx.timestamp,
                flagged: 1
              }, 'localhost');
            case 3:
              _context27.n = 5;
              break;
            case 4:
              _context27.n = 5;
              return this.app.storage.loadTransactions({
                sig: txmsg.data.signature,
                field1: 'RedSquare'
              }, /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(txs) {
                  var archived_tx;
                  return _regenerator().w(function (_context26) {
                    while (1) switch (_context26.n) {
                      case 0:
                        if (!((txs === null || txs === void 0 ? void 0 : txs.length) > 0)) {
                          _context26.n = 1;
                          break;
                        }
                        archived_tx = txs[0];
                        archived_tx.optional.curated = -1;
                        _context26.n = 1;
                        return _this14.app.storage.updateTransaction(archived_tx, {
                          updated_at: tx.timestamp,
                          flagged: 1
                        }, 'localhost');
                      case 1:
                        return _context26.a(2);
                    }
                  }, _callee26);
                }));
                return function (_x67) {
                  return _ref9.apply(this, arguments);
                };
              }(), 'localhost');
            case 5:
              //
              // let both users know that something happened
              //
              if (app.BROWSER == 1) {
                if (tx.isTo(this.publicKey)) {
                  if (tx.isFrom(this.publicKey)) {
                    siteMessage('Tweet successfully flagged for review', 3000);
                  } else {
                    siteMessage('One of your tweets was flagged for review', 10000);
                  }
                } else {
                  console.info("RS.receiveFlagTransaction: Your friend [".concat(this.app.keychain.returnUsername(tx.from[0].publicKey), "] flagged a tweet -- "), flagged_tweet.text);
                }
              }
              return _context27.a(2);
          }
        }, _callee27, this);
      }));
      function receiveFlagTransaction(_x63, _x64, _x65, _x66) {
        return _receiveFlagTransaction.apply(this, arguments);
      }
      return receiveFlagTransaction;
    }()
  }, {
    key: "saveTweet",
    value: function saveTweet(tweet) {
      var _this15 = this;
      var preserve = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var blk = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!tweet) {
        console.warn('RS.saveTweet: no tweet!');
        return;
      }
      if (!tweet.thread_id) {
        // Don't save ...
        return;
      }

      //
      // if i interact with a tweet, mark it as curated
      //
      if (preserve) {
        tweet.tx.optional.curated = 1;
      }

      //
      // this transaction is TO me, but I may not be the tx.to[0].publicKey address, and thus the archive
      // module may not index this transaction for me in a way that makes it very easy to fetch (field3 = MY_KEY}
      // thus we override the defaults by setting field3 explicitly to our publickey so that loading transactions
      // from archives by fetching on field3 will get this.
      //
      var opt = {
        field1: 'RedSquare',
        //defaults to module.name, but just to make sure we match the capitalization with our loadTweets
        preserve: preserve,
        field4: tweet.parent_id || '',
        field5: tweet.thread_id
      };

      /*console.log({
        sig: tweet.tx.signature,
        text: tweet.text,
        parent: tweet.parent_id,
        thread: tweet.thread_id
      });*/

      if (tweet.tx.isTo(this.publicKey)) {
        //
        // when a browser stores tweets, it is storing tweets it sent or were sent to it
        // this will help use with notifications (to) and profile (from)
        //
        opt['field3'] = this.publicKey;
      }

      //
      // Save the modified tx so we have open graph properties available
      //

      this.app.storage.loadTransactions({
        field1: 'RedSquare',
        sig: tweet.tx.signature
      }, function (txs) {
        if ((txs === null || txs === void 0 ? void 0 : txs.length) > 0) {
          _this15.app.storage.updateTransaction(tweet.tx, opt, 'localhost', 1);
        } else {
          _this15.app.storage.saveTransaction(tweet.tx, opt, 'localhost', blk);
        }
      }, 'localhost');
    }
  }, {
    key: "updateSavedTweet",
    value: function updateSavedTweet(sig) {
      var tweet = this.returnTweet(sig);
      if (!tweet) {
        console.warn('RS.updateTweet: tweet not found!', sig);
        return;
      }
      this.app.storage.updateTransaction(tweet.tx, {}, 'localhost');
    }

    /////////////////////////////////////
    // saving and loading wallet state //
    /////////////////////////////////////
  }, {
    key: "loadOptions",
    value: function loadOptions() {
      if (!this.app.BROWSER) {
        return;
      }
      if (this.app.options.redsquare) {
        var rso = this.app.options.redsquare;
        this.notifications_last_viewed_ts = (rso === null || rso === void 0 ? void 0 : rso.notifications_last_viewed_ts) || 0;
        this.notifications_number_unviewed = (rso === null || rso === void 0 ? void 0 : rso.notifications_number_unviewed) || 0;
        this.tweet_count = (rso === null || rso === void 0 ? void 0 : rso.tweet_count) || 0;
        this.liked_tweets = (rso === null || rso === void 0 ? void 0 : rso.liked_tweets) || [];
        this.retweeted_tweets = (rso === null || rso === void 0 ? void 0 : rso.retweeted_tweets) || [];
        this.replied_tweets = (rso === null || rso === void 0 ? void 0 : rso.replied_tweets) || [];
        this.hidden_tweets = (rso === null || rso === void 0 ? void 0 : rso.hidden_tweets) || [];
        if ((rso === null || rso === void 0 ? void 0 : rso.curated) == 0) {
          this.curated = false;
        }
      }
      this.saveOptions();
    }
  }, {
    key: "saveOptions",
    value: function saveOptions() {
      if (!this.app.BROWSER) {
        return;
      }
      var rso = {};
      rso.notifications_last_viewed_ts = this.notifications_last_viewed_ts;
      rso.notifications_number_unviewed = this.notifications_number_unviewed;
      rso.tweet_count = this.tweet_count;
      rso.liked_tweets = this.liked_tweets.slice(-100);
      rso.retweeted_tweets = this.retweeted_tweets.slice(-100);
      rso.replied_tweets = this.replied_tweets.slice(-100);
      rso.hidden_tweets = this.hidden_tweets;
      rso.curated = this.curated;
      this.app.options.redsquare = rso;
      this.app.storage.saveOptions();
    }

    //////////////
    // remember //
    //////////////
  }, {
    key: "likeTweet",
    value: function likeTweet(tweet) {
      var _tweet$tx;
      if (!(tweet !== null && tweet !== void 0 && (_tweet$tx = tweet.tx) !== null && _tweet$tx !== void 0 && _tweet$tx.signature)) {
        return;
      }
      if (!this.liked_tweets.includes(tweet.tx.signature)) {
        this.liked_tweets.push(tweet.tx.signature);
        this.saveTweet(tweet);
      }
      this.saveOptions();
    }
  }, {
    key: "retweetTweet",
    value: function retweetTweet(tweet) {
      var _tweet$tx2;
      if (!(tweet !== null && tweet !== void 0 && (_tweet$tx2 = tweet.tx) !== null && _tweet$tx2 !== void 0 && _tweet$tx2.signature)) {
        return;
      }
      if (!this.retweeted_tweets.includes(tweet.tx.signature)) {
        this.retweeted_tweets.push(tweet.tx.signature);
        this.saveTweet(tweet);
      }
      this.saveOptions();
    }
  }, {
    key: "replyTweet",
    value: function replyTweet(tweet) {
      var _tweet$tx3;
      if (!(tweet !== null && tweet !== void 0 && (_tweet$tx3 = tweet.tx) !== null && _tweet$tx3 !== void 0 && _tweet$tx3.signature)) {
        return;
      }
      if (!this.replied_tweets.includes(tweet.tx.signature)) {
        this.replied_tweets.push(tweet.tx.signature);
        this.saveTweet(tweet);
      }
      this.saveOptions();
    }
  }, {
    key: "addBlogPseudoTweets",
    value: function addBlogPseudoTweets() {
      var _iterator9 = _createForOfIteratorHelper(this.blogs),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var b = _step9.value;
          if (b.ts > this.tweets_earliest_ts && !this.tweets_sigs_hmap[b.tx_id]) {
            // "Add Tweet"
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "cacheRecentTweets",
    value: function cacheRecentTweets() {
      var force_caching = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.app.BROWSER) {
        return;
      }
      var ts = new Date().getTime();
      if (!force_caching && this.last_cache + 300000 > ts) {
        /*console.debug(
          '###\n### RS.cacheRecentTweets -- too soon to recalculate! \n###\n###',
          this.cached_tweets.length
        );*/
        return;
      }
      this.last_cache = ts;
      this.cached_tweets = [];
      var _iterator0 = _createForOfIteratorHelper(this.tweets),
        _step0;
      try {
        for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
          var tweet = _step0.value;
          //
          // Update curation (because we maybe have more named keys)
          //
          tweet.curated = this.curate(tweet.tx);
          if (tweet.curated == 1) {
            tweet.tx.optional.curated = 1;
            if (!tweet.game) {
              this.cached_tweets.push(tweet.tx.serialize_to_web(this.app));
            }
          }
        }
      } catch (err) {
        _iterator0.e(err);
      } finally {
        _iterator0.f();
      }
      if (this.debug) {
        console.debug("###\n### RS.cacheRecentTweets -- Tweets: ".concat(this.tweets.length, " Cached: ").concat(this.cached_tweets.length, " \n###"));
      }

      // Keep at most 9 curated tweets
      this.cached_tweets = this.cached_tweets.slice(0, 9);
      var test_tweet = true;

      // Add at least 1 non-curated tweets
      if (this.cached_tweets.length < 10) {
        for (var z = 0; z < this.tweets.length && this.cached_tweets.length < 10; z++) {
          if (this.tweets[z].curated == 0) {
            if (test_tweet) {
              //
              // We add the most recent 'curated = 0' tweet as a test tweet
              //
              test_tweet = false;
              this.tweets[z].tx.optional.curated = 0;
              this.tweets[z].tx.optional.curation_check = true;
              this.cached_tweets.push(this.tweets[z].tx.serialize_to_web(this.app));
            } else {
              var _this$tweets$z$images;
              //
              // For the fallback, let's keep some automated standards to pull out better content
              // Theoretically, we should only have a problem the first time this code is deployed
              // afterwards we will have seeded enough whitelisted keys and positively curated tweets
              // that repeated deployments will pick up the vetted content
              //
              var score = Math.log(this.tweets[z].num_likes + 1);
              score += this.tweets[z].num_retweets;
              score += Math.log(this.tweets[z].num_replies + 1) / Math.log(2);
              if ((_this$tweets$z$images = this.tweets[z].images) !== null && _this$tweets$z$images !== void 0 && _this$tweets$z$images.length) {
                score += 3 * this.tweets[z].images.length;
              }
              if (score > 10) {
                this.tweets[z].tx.optional.curated = 0;
                this.cached_tweets.push(this.tweets[z].tx.serialize_to_web(this.app));
              }
            }
          }
        }
      }
    }
  }, {
    key: "fetchMissingUsernames",
    value: function fetchMissingUsernames() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var keylist = [];
      for (var i = 0; i < this.tweets.length; i++) {
        if (!keylist.includes(this.tweets[i].tx.from[0].publicKey)) {
          keylist.push(this.tweets[i].tx.from[0].publicKey);
        }
      }
      var rMod = this.app.modules.returnModule('Registry');
      if (rMod) {
        rMod.fetchManyIdentifiers(keylist, function (answer) {
          if (mycallback != null) {
            mycallback(answer);
          }
        });
      } else {
        console.warn('No Registry');
      }
    }

    /******************************
     * Make RedSquare Curation Settings
     * visibile outside of RS
     *****************************/
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!container) {
        var overlay = new SaitoOverlay(this.app, this.mod);
        overlay.show("<div class=\"module-settings-overlay\"><h2>Redsquare Settings</h2></div>");
        container = '.module-settings-overlay';
      }
      var as = new AppSettings(this.app, this, container);
      as.render();
    }

    ///////////////
    // webserver //
    ///////////////
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var alternative_slug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var uri = alternative_slug || '/' + encodeURI(this.returnSlug());
      var redsquare_self = this;
      expressapp.use(uri, express["static"](webdir));
      expressapp.get(uri, /*#__PURE__*/function () {
        var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(req, res) {
          var reqBaseURL, query_params, sig, _sig, html, _t4;
          return _regenerator().w(function (_context28) {
            while (1) switch (_context28.p = _context28.n) {
              case 0:
                reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                _context28.p = 1;
                if (!(Object.keys(req.query).length > 0)) {
                  _context28.n = 3;
                  break;
                }
                query_params = req.query;
                sig = (query_params === null || query_params === void 0 ? void 0 : query_params.tweet_id) || (query_params === null || query_params === void 0 ? void 0 : query_params.thread_id);
                if (!sig) {
                  _context28.n = 2;
                  break;
                }
                app.storage.loadTransactions({
                  sig: sig,
                  field1: 'RedSquare'
                }, function (txs) {
                  if (txs.length > 0) {
                    var tx = txs.shift();
                    tx.decryptMessage(app);
                    var returned_tweet = new Tweet(app, redsquare_self, tx);
                    var updated_social = redsquare_self.social;
                    var text = returned_tweet.text;
                    var user = app.keychain.returnUsername(tx.from[0].publicKey);

                    //
                    // We need adequate protection here
                    //
                    var url = reqBaseURL + encodeURI(redsquare_self.returnSlug());
                    var image = url + '?og_img_sig=' + sig;
                    updated_social = {
                      twitter: '@SaitoOfficial',
                      title: user + ' posted on Saito 🟥',
                      url: url,
                      description: app.browser.escapeHTML(text),
                      image: image
                    };
                    app.storage.loadTransactions({
                      field1: 'RedSquare',
                      field5: returned_tweet.thread_id,
                      flagged: 0,
                      limit: 100
                    }, function (raw_txs) {
                      var html = redsquareHome(app, redsquare_self, app.build_number, updated_social, raw_txs);
                      if (!res.finished) {
                        res.setHeader('Content-type', 'text/html');
                        res.charset = 'UTF-8';
                        return res.send(html);
                      }
                    }, 'localhost', 0);
                  }
                }, 'localhost');
                return _context28.a(2);
              case 2:
                if (!(typeof query_params.og_img_sig != 'undefined')) {
                  _context28.n = 3;
                  break;
                }
                _sig = query_params.og_img_sig;
                redsquare_self.loadTweetWithSig(_sig, function (txs) {
                  for (var i = 0; i < txs.length; i++) {
                    var _txmsg$data2;
                    var tx = txs[i];
                    var txmsg = tx.returnMessage();
                    var img = '';
                    var img_type = void 0;
                    if (((_txmsg$data2 = txmsg.data) === null || _txmsg$data2 === void 0 || (_txmsg$data2 = _txmsg$data2.images) === null || _txmsg$data2 === void 0 ? void 0 : _txmsg$data2.length) > 0) {
                      var img_uri = txmsg.data.images[0];
                      img_type = img_uri.substring(img_uri.indexOf(':') + 1, img_uri.indexOf(';'));
                      var base64Data = img_uri.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
                      img = Buffer.from(base64Data, 'base64');
                    } else {
                      var publicKey = tx.from[0].publicKey;
                      var _img_uri = app.keychain.returnIdenticon(publicKey, 'png');
                      var _base64Data = _img_uri.replace(/^data:image\/png;base64,/, '');
                      img = Buffer.from(_base64Data, 'base64');
                      img_type = _img_uri.substring(_img_uri.indexOf(':') + 1, _img_uri.indexOf(';'));
                    }
                    if (img_type == 'image/svg+xml') {
                      img_type = 'image/svg';
                    }
                    if (!res.finished) {
                      res.writeHead(200, {
                        'Content-Type': img_type,
                        'Content-Length': img.length
                      });
                      return res.end(img);
                    }
                  }
                });
                return _context28.a(2);
              case 3:
                _context28.n = 5;
                break;
              case 4:
                _context28.p = 4;
                _t4 = _context28.v;
              case 5:
                redsquare_self.cacheRecentTweets();
                if (res.finished) {
                  _context28.n = 6;
                  break;
                }
                html = redsquareHome(app, redsquare_self, app.build_number, redsquare_self.social, redsquare_self.cached_tweets);
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context28.a(2, res.send(html));
              case 6:
                return _context28.a(2);
            }
          }, _callee28, null, [[1, 4]]);
        }));
        return function (_x68, _x69) {
          return _ref0.apply(this, arguments);
        };
      }());
    }

    // This needs to be a separate function from basic moderation, because users
    // will want to toggle it on/off, but moderation happens at the core and blocks
    // even receiving transactions
  }, {
    key: "curate",
    value: function curate(tx) {
      // MODERATE first
      // accept black and white lists as authoritative before defaulting to tweet analysis
      //

      var moderation_score = this.app.modules.moderate(tx, this.name);
      if (moderation_score == 1) {
        return 1;
      }
      if (moderation_score == -1) {
        return -1;
      }

      // My contacts get through
      if (this.app.keychain.hasPublicKey(tx.from[0].publicKey)) {
        return 1;
      }
      if (tx.to[0].amount) {
        //console.log('Auto approve moneyed tweets: ', tx.to[0].amount);
        return 1;
      }

      // Allow us to cache curated status (preferably just "1") in local archives
      if (tx.optional.curated !== undefined) {
        return tx.optional.curated;
      }
      return 0;
    }
  }, {
    key: "packTweetThread",
    value: function packTweetThread(tweet) {
      var txs = [];
      var processTX = function processTX(tweet) {
        // tweet.updated_at may get updated independently of the optional...
        tweet.tx.optional.updated_at = tweet.updated_at;
        var r = tweet.tx.serialize_to_web(tweet.app);
        return r;
      };
      txs.push(processTX(tweet));
      for (var i = 0; i < tweet.children.length; i++) {
        txs = txs.concat(this.packTweetThread(tweet.children[i]));
      }
      return txs;
    }
  }, {
    key: "dbCleanUp",
    value: function () {
      var _dbCleanUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30() {
        var _this16 = this;
        var earlier_than,
          _args30 = arguments;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              earlier_than = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : Date.now();
              this.app.storage.loadTransactions({
                field1: 'RedSquare',
                field5: '',
                created_earlier_than: earlier_than,
                limit: 100
              }, /*#__PURE__*/function () {
                var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(txs) {
                  var counts, _iterator1, _step1, tx, txmsg, tweet, _iterator10, _step10, xmod;
                  return _regenerator().w(function (_context29) {
                    while (1) switch (_context29.n) {
                      case 0:
                        counts = {
                          total: 0,
                          game: 0,
                          reply: 0,
                          feed: 0
                        };
                        _iterator1 = _createForOfIteratorHelper(txs);
                        try {
                          for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
                            tx = _step1.value;
                            txmsg = tx.returnMessage();
                            if (txmsg.request === 'create tweet') {
                              tweet = new Tweet(_this16.app, _this16, tx);
                              _iterator10 = _createForOfIteratorHelper(_this16.app.modules.respondTo('redsquare-add-tweet'));
                              try {
                                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                                  xmod = _step10.value;
                                  tweet = xmod.respondTo('redsquare-add-tweet').processTweet(tweet);
                                }
                              } catch (err) {
                                _iterator10.e(err);
                              } finally {
                                _iterator10.f();
                              }
                              counts.total++;
                              if (tweet.game) {
                                counts.game++;
                              }
                              if (tweet.parent_id) {
                                counts.reply++;
                              } else {
                                counts.feed++;
                              }
                              _this16.saveTweet(tweet);
                            }
                            if (tx.timestamp < earlier_than) {
                              earlier_than = tx.timestamp;
                            }
                          }
                        } catch (err) {
                          _iterator1.e(err);
                        } finally {
                          _iterator1.f();
                        }
                        if (txs.length) {
                          console.log("Batch processed: ".concat(counts.total, " transactions... ").concat(counts.game, " games, ").concat(counts.reply, " replies"));
                          setTimeout(function () {
                            _this16.dbCleanUp(earlier_than);
                          }, 15000);
                        } else {
                          console.log('######################## \n \n Finished !!!!!!!!!!! \n \n ###########################');
                        }
                      case 1:
                        return _context29.a(2);
                    }
                  }, _callee29);
                }));
                return function (_x70) {
                  return _ref1.apply(this, arguments);
                };
              }(), 'localhost');
            case 1:
              return _context30.a(2);
          }
        }, _callee30, this);
      }));
      function dbCleanUp() {
        return _dbCleanUp.apply(this, arguments);
      }
      return dbCleanUp;
    }()
  }]);
}(ModTemplate);
module.exports = RedSquare;